import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { FormControl, FormGroup } from '@angular/forms';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { CustomPaymentsAuthService } from 'src/app/services/custom-payments-auth.service';

@Component({
  selector: 'app-custom-sales-payments',
  templateUrl: './custom-sales-payments.component.html',
  styleUrls: ['./custom-sales-payments.component.scss']
})
export class CustomSalesPaymentsComponent implements OnInit {

  customSalesFilterForm: any;
  order: {};
  limit: number;
  page: number;
  count: number;
  maxPage: number;
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'CustomPayment.id': 'DESC' };
  filtered = {};
  groups: any;
  customSalePayments: any[] = [];

  constructor(
    private authStatusService: AuthStatusService,
    private route: ActivatedRoute,
    private router: Router,
    private commanUsesService: CommanUsesService,
    private customPaymentsAuthService: CustomPaymentsAuthService,
  ) { 
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
  }

  async ngOnInit() {
    try {
      this.manageCustomSalesFilterForm();
      await this.filter();
    } catch (error) {
      console.log("ERROR", error?.message);
    }
  }

  manageCustomSalesFilterForm() {
    this.customSalesFilterForm = new FormGroup({
      'CustomPayment.id': new FormControl(''),
      'CustomPayment.paymentStatus': new FormControl(''),
      'CustomPayment.currency': new FormControl(''),
      'CustomPayment.amount': new FormControl(''),
      'ShopifySale.id': new FormControl(''),
      'CustomPayment.platform': new FormControl(''),
      // 'Provinces.province': new FormControl(''),
      // 'Provinces.provinceCode': new FormControl(''),
    })
  }

  async filter() {
    let filterForm = (new FormGroupToObject()).transform(this.customSalesFilterForm);
    this.filtered = {};
    if (filterForm['CustomPayment.id'])
      this.filtered['CustomPayment.id'] = filterForm['CustomPayment.id'];  
    if (filterForm['ShopifySale.id'])
      this.filtered['ShopifySale.id'] = filterForm['ShopifySale.id'];  
    if (filterForm['CustomPayment.paymentStatus'])
      this.filtered['CustomPayment.paymentStatus'] = { operator: 'like', values: [`%${filterForm['CustomPayment.paymentStatus']}%`]};
    if (filterForm['CustomPayment.currency'])
      this.filtered['CustomPayment.currency'] = { operator: 'like', values: [`%${filterForm['CustomPayment.currency']}%`]};
    if (filterForm['CustomPayment.amount'])
      this.filtered['CustomPayment.amount'] = { operator: 'like', values: [`%${filterForm['CustomPayment.amount']}%`]};
    if (filterForm['CustomPayment.platform'])
      this.filtered['CustomPayment.platform'] = { operator: 'like', values: [`%${filterForm['CustomPayment.platform']}%`]};
    await this.loadSalePayemts();
  }

  async loadSalePayemts(limit?: number, page?: number, order?: {}) {
    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
    let customSalePayments = await this.customPaymentsAuthService.getAllSalePayments(this.page, this.limit, this.order, this.filtered);
    this.customSalePayments = customSalePayments.customSalePayments;
    this.count = customSalePayments.count;
    this.maxPage = Math.ceil(this.count / this.limit);
  }
  
  async resetFliter() {
    this.manageCustomSalesFilterForm();
    await this.filter();
  }

  salePaymentStatusClass(payment: any) {
    if(payment.paymentStatus === 'succeeded') {
      return 'paid-chip';
    } else if(payment.paymentStatus === 'failed') {
      return 'not-payable-chip';
    } else {
      return 'default'
    }
  }

  showPaymentStatus(payment: any) {
    if(payment.paymentStatus === 'succeeded') {
      return 'SUCCESS';
    } else if(payment.paymentStatus === 'failed') {
      return 'FAILED';
    } else {
      return 'DEFAULT'
    }
  }

  getSaleId(payment: any): string {
    const platform = payment?.platform?.toLowerCase();
    const salePayment = payment?.customSalePayments?.[0];

    if (!platform || !salePayment) return '---';

    switch (platform) {
      case 'shopifysale':
        return salePayment?.shopifySale?.id ?? '---';
      case 'cakesales':
        return salePayment?.cakeSales?.id ?? '---';
      case 'flowerssales':
        return salePayment?.flowersSales?.id ?? '---';
      case 'businesssales':
        return salePayment?.businessSales?.id ?? '---';
      case 'deluxyexperiencesales':
        return salePayment?.deluxyExperienceSales?.id ?? '---';
      case 'deluxydotcomsales':
        return salePayment?.deluxyDotComSales?.id ?? '---';
      default:
        return '---';
    }
  }


  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

  public async navigateOrder(attribute: string | string[]) {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async (data) => {
      await this.loadSalePayemts();
    });
  }

  async navigate(event) {
    await this.loadSalePayemts(event.limit, event.page, this.order);
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

}
